import { render } from "./UploadAlertBadFormatModal.vue?vue&type=template&id=1ac4d51a"
import script from "./UploadAlertBadFormatModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadAlertBadFormatModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/UploadAlertBadFormatModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ac4d51a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ac4d51a', __exports__)) {
    api.reload('1ac4d51a', __exports__)
  }
  
  module.hot.accept("./UploadAlertBadFormatModal.vue?vue&type=template&id=1ac4d51a", () => {
    api.rerender('1ac4d51a', render)
  })

}


export default __exports__